import { render, staticRenderFns } from "./CandidatePhotoRow.vue?vue&type=template&id=4cd730b5"
import script from "./CandidatePhotoRow.vue?vue&type=script&lang=js"
export * from "./CandidatePhotoRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports